<template>
    <KeepAlive>
        <template v-for="(meta, index) in entity[component]?.metas?.filter((meta) => {
            return meta.entity_type === this.entity_type.toUpperCase()
                && !['form'].includes(meta.type)
        })" :key="index">
            <template v-if="visibilities[meta.key] === 'visible'">

                <div v-if="meta.type === 'span' || meta.type === 'space' || meta.type === 'line'"
                    class="flex center vcenter" :class="[{ 'line': meta.type === 'line' }]"
                    :style="{ 'width': meta.style ? JSON.parse(meta.style)['width'] : '100%' }">
                    <span v-if="meta.type === 'span'" :style="Object.assign(meta.style ? JSON.parse(meta.style) : ''
                        , { 'width': '100% !important' })"
                        :class="[{ 'coloric': extras[component]?.[meta.key]?.coloric }]">
                        {{ extras[component]?.[meta.key]?.description }}
                    </span>
                </div>

                <div v-else-if="meta.type === 'head'" class="head">
                    <div class="title">
                        <h1>{{ meta.name }}</h1>
                    </div>
                </div>

                <div v-else-if="meta.type === 'list'" class="list">
                    <List :entity_type="extras[component]?.[meta.key]?.entity_type || ''"
                        :entity_data="_entity_data(meta.name, extras[component] ? extras[component][meta.key] : {})"
                        :page="1" :size="1500" @onloading="onloading">
                    </List>
                </div>

                <Accordion v-else-if="meta.type === 'accordion'" :title="base.Entities().parse(meta.extras)['title']"
                    :description="base.Entities().parse(meta.extras)['description']" :id="id">
                </Accordion>

                <Reply v-else-if="meta.type === 'reply'" :meta="meta" :id="id" @onchange="onchange">
                </Reply>

                <div v-else-if="meta.type === 'tab' || meta.type === 'step'" class="full tab flex wrap center vcenter">
                    <Tabs :meta="meta" :vm="_models[component][meta.key]" :id="id"
                        :data="extras[component][meta.key]['contents'] || 'L'" :disabled="disabled[meta.key]"
                        @onchange="onchange">
                    </Tabs>
                </div>

                <Switch v-else-if="meta.type === 'switch'" :meta="meta" :vm="_models[component][meta.key]" :id="id"
                    :disabled="disabled[meta.key]" @onchange="onchange">
                </Switch>

                <DragBox v-else-if="meta.type === 'files'" :meta="meta" :vm="_models[component][meta.key]" :id="id"
                    :disabled="disabled[meta.key]" @onchange="onchange">
                </DragBox>

                <MultiParams v-else-if="meta.type === 'multiparams'" :meta="{
                    entity: meta,
                    metas: entity[component]?.metas?.filter((element) => {
                        return element.entity_type === `${this.entity_type.toUpperCase()}_${meta.key.toUpperCase()}`
                    }),
                    extras: extras[component],
                    disabled: disabled
                }" :vm="_models[component][meta.key]" :id="id" :validate="errors[meta.key]"
                    :disabled="disabled[meta.key]" @onchange="onchange">
                </MultiParams>

                <Recipients v-else-if="meta.type === 'recipients'" :meta="meta" :vm="_models[component][meta.key]"
                    :id="id" :active="focus === meta.key" :validate="errors[meta.key]" :disabled="disabled[meta.key]"
                    @onchange="onchange">
                </Recipients>

                <Editor v-else-if="meta.type === 'editor'" :meta="meta" :vm="_models[component][meta.key]" :id="id"
                    :disabled="disabled[meta.key]" @onfocus="onfocus" @onchange="onchange">
                </Editor>

                <MetaBox v-else :meta="meta" :vm="_models[component][meta.key]"
                    :data="meta.type === 'dropdown' || meta.type === 'multidrop' ? extras[component][meta.key]['contents'] || 'L' : {}"
                    :id="id" :active="focus === meta.key" :validate="errors[meta.key]" :disabled="disabled[meta.key]"
                    :internal="internal" @onfocus="onfocus" @onchange="onchange">
                </MetaBox>

            </template>
        </template>
    </KeepAlive>
</template>

<script>
/* eslint-disable */
import { defineAsyncComponent } from 'vue'

import Accordion from './Accordion.vue'
import Reply from './Inputs/Reply.vue'
import Tabs from './Inputs/Tabs.vue'
import Switch from './Inputs/Switch.vue'
import DragBox from './Inputs/DragBox.vue'
import MultiParams from './Inputs/MultiParams.vue'
import Recipients from './Inputs/Recipients.vue'
import MetaBox from './Inputs/MetaBox.vue'

export default {
    name: 'Fields',
    props: ['entity_type', 'id', 'component', 'entity', 'contents', 'accesses', 'dynamic', 'internal'],
    inject: ['base'],
    components: {
        Accordion, Reply, Tabs, Switch, DragBox, MultiParams, Recipients, MetaBox
        , Editor: defineAsyncComponent(() => import('./Inputs/Editor.vue'))
        , List: defineAsyncComponent(() => import('../List.vue'))
    },
    computed: {
        query() {
            return this.entity[this.component]?.properties?.query
        }
    },
    created() {
        this.init()
    },
    destroyed() {
        window.removeEventListener('resize', this.width)
    },
    data() {
        return {
            extras: {},
            disabled: {},
            visibilities: {},
            models: {},
            _models: {},
            hints: {},
            focus: '',
            errors: {},
            files: []
        }
    },
    watch: {
        entity_type(newEntity, oldEntity) {
            this.init()
        },
        $route(newRoute, oldRoute) {
            if (newRoute.params.entity_type === oldRoute.params.entity_type)
                this.init()
            else
                Object.keys(this.$route.query).forEach((key) => {
                    this._models[this.component][key] = this.$route.query?.[key]
                    this.models[this.component][key] = this.$route.query?.[key]
                })
        },
        query(newQuery, oldQuery) {
            let queries = this.entity[this.component]?.properties?.query
            Object.keys(queries).forEach(key => this.$route.query[key] = queries[key])
        },
        visibilities: {
            handler(newVisibilities, oldVisibilities) {
                this.$emit('onvisibilities', { visibilities: this.visibilities })
            },
            deep: true
        },
        extras: {
            handler(newExtras, oldExtras) {
                this.$emit('onextras', { extras: this.extras })
            },
            deep: true
        },
        models: {
            handler(newModels, oldModels) {
                this.visibility()
                this.entity[this.component]?.metas?.forEach((meta) => {
                    if (meta.extras)
                        if (meta.extras.includes('key=synthetic')) {
                            let value = ''
                            let keys = this.extras[this.component]?.[meta.key]?.['synthetic']
                            if (keys)
                                if (keys.includes('|'))
                                    keys.split('|').forEach((key) => value += key.includes('key(')
                                        ? this.models[this.component][key.replace('key(', '').replace(')', '')] || '' : key)
                                else
                                    value = this.models[this.component][keys]

                            if (value && this.base.Util().validate(value.replaceAll(' ', ''))) {
                                this._models[this.component][meta.key] = String(value).replaceAll('  ', ' ')
                                this.models[this.component][meta.key] = String(value).replaceAll('  ', ' ')
                            } else if (String(value).trim() === '') {
                                this._models[this.component][meta.key] = ''
                                this.models[this.component][meta.key] = ''
                            }

                        } else if (meta.extras.includes('key=math')) {
                            let keys = this.extras[this.component][meta.key]['math']
                            let item = keys.split(keys.includes('+') ? '+'
                                : keys.includes('-') ? '-'
                                    : keys.includes('*') ? '*'
                                        : '/')
                            item = keys.includes('+') ? String(Number(this.models[this.component][item[0]]?.replace(/\s/g, '').replace(/,/g, '')) + Number(item[1]))
                                : keys.includes('-') ? String(Number(this.models[this.component][item[0]]?.replace(/\s/g, '').replace(/,/g, '')) - Number(item[1]))
                                    : keys.includes('*') ? String(Number(this.models[this.component][item[0]]?.replace(/\s/g, '').replace(/,/g, '')) * Number(item[1]))
                                        : String(Number(this.models[this.component][item[0]]?.replace(/\s/g, '').replace(/,/g, '')) / Number(item[1]))
                            if (this.base.Util().validate(item) && item !== 'NaN' && item !== '0')
                                this._models[this.component][meta.key] = item
                            else
                                this._models[this.component][meta.key] = ''
                        }
                })
                this.$emit('onchange', {
                    models: this.models,
                    hints: this.hints,
                    errors: this.errors
                })
            },
            deep: true
        }
    },
    methods: {
        _entity_data(title, extras) {
            return {
                title: title,
                properties: {
                    allowed: extras?.allowed,
                    excludes: extras?.excludes,
                    query: this._query(extras),
                    ADD: 'NO',
                    REMOVE: 'NO',
                    EXPORT: extras?.export,
                    options: extras?.options,
                    SUBFORM: true,
                    SUBLIST: true,
                },
                options: {}
            }
        },
        _query(extras) {
            if (Array.isArray(extras?.query))
                return extras?.query?.reduce((obj, key) => {
                    obj[key] = String(extras?.[key])?.includes('params')
                        ? this.$route.params[String(extras?.[key]).replace('params(', '').replace(')', '')] || 'NaN'
                        : extras?.[key].includes('key')
                            ? this.models[this.component]?.[String(extras?.[extras?.key]).replace('key(', '').replace(')', '')] || 'NaN'
                            : extras?.[key]
                    return obj
                }, {})
            else {
                let obj = {}
                let value = String(extras?.[extras?.query])?.includes('params')
                    ? this.$route.params[String(extras?.[extras?.query]).replace('params(', '').replace(')', '')] || 'NaN'
                    : String(extras?.[extras?.query]).includes('key')
                        ? this.models[this.component]?.[String(extras?.[extras?.query]).replace('key(', '').replace(')', '')] || 'NaN'
                        : extras?.[extras?.query]
                if (value)
                    obj[extras?.query] = value
                return obj
            }
        },
        init() {
            this.models[this.component] = {}
            this._models[this.component] = {}
            this.hints[this.component] = {}
            this.errors[this.component] = {}
            this.extras[this.component] = {}

            this.builder()

            this.entity[this.component]?.metas?.forEach((meta) => {
                this.extras[this.component][meta.key] = this.base.Entities().parse(meta.extras)
                if (meta.extras) {
                    if (meta.extras.includes('key=default')
                        && !this.base.Util().validate(this.models[this.component][meta.key])) {
                        let _default = this.extras[this.component][meta.key]['default']
                        if (Array.isArray(_default))
                            _default.forEach((element) => {
                                this._models[this.component][meta.key] = element
                                this.models[this.component][meta.key] = element
                            })
                        else {
                            this._models[this.component][meta.key] = _default
                            this.models[this.component][meta.key] = this._models[this.component][meta.key]
                        }
                    }

                    if (meta.extras.includes('key=env')
                        && !this.base.Util().validate(this.models[this.component][meta.key])) {
                        let env = this.extras[this.component][meta.key]['env']

                        if (!this.id)
                            this.base.API().get(`Data/Value/Environment?key=${env}`,
                                (response) => {
                                    if (this.base.Util().success(response))
                                        if (this.base.Util().validate(response.data.data)) {
                                            this._models[this.component][meta.key] = response.data.data.value
                                            this.models[this.component][meta.key] = response.data.data.value
                                        }
                                })
                    }

                    if (meta.extras.includes('key=params')
                        && !this.base.Util().validate(this.models[this.component][meta.key])) {
                        let params = this.extras[this.component][meta.key]['params']

                        if (this.$route.params[params]) {
                            this._models[this.component][meta.key] = this.$route.params[params]
                            this.models[this.component][meta.key] = this.$route.params[params]
                        }
                    }

                    if (meta.extras.includes('key=synthetic')) {
                        let value = ''
                        let keys = this.extras[this.component][meta.key]['synthetic']
                        if (keys.includes('|'))
                            keys.split('|').forEach((key) => value += key.includes('key(')
                                ? this.models[key.replace('key(', '').replace(')', '')] || '' : key)
                        else
                            value = this.models[this.component][keys]

                        if (value && this.base.Util().validate(value.replaceAll(' ', '')))
                            this.models[this.component][meta.key] = value
                    }

                    if (meta.extras.includes('key=args')) {
                        let args = this.extras[this.component][meta.key]['args']
                        if (!Array.isArray(args))
                            args = [args]
                        for (let index = 0; index < args.length; index++)
                            this.extras[this.component][meta.key]['description'] = this.extras[this.component][meta.key]['description']
                                .replace(`%p${index}%`, atob(args[index]))
                    }
                }

                this.disabled[meta.key] = true
                let access = (this.accesses[meta.key] || this.accesses['persist'] || 'deny')
                if (access) {
                    if (this.accesses['persist'] === 'accept')
                        this.disabled[meta.key] = false
                    else if (access === 'accept' || access === 'deny') {
                        this.disabled[meta.key] = meta.disabled

                        if (!this.disabled[meta.key] && this.id)
                            this.disabled[meta.key] = !meta.editable

                        if (!this.disabled[meta.key])
                            this.disabled[meta.key] = access === 'accept' ? false : true
                    }
                }
            })
            this.width()
            window.addEventListener('resize', this.width)
        },
        builder() {
            if (this.entity_type) {
                this.base.API().get(`Data/Entity/Builder?entity_type=${this.entity_type}`, (response) => {
                    if (this.base.Util().success(response)
                        && this.base.Util().validate(response.data.data))
                        Object.keys(response.data.data).forEach((key) => this.base.Entities().data(response.data.data[key], 'static', (data) => this.extras[this.component][key]['contents'] = data))
                }, (error) => {
                })

                if (this.base.Util().validate(this.id)) {
                    this.$emit('onloading', true)
                    this.base.API().post('Service/Global/Find', {
                        entity_type: 'ATTACHMENT',
                        data: {
                            parent_id: `${this.entity_type?.toUpperCase()}_${this.id}`,
                            status: 100
                        }
                    }, (response) => {
                        if (this.base.Util().success(response))
                            response.data.data.forEach((file) => {
                                let meta = this.entity[this.component]?.metas?.find((meta) => meta.key === (file.extras.includes(':')
                                    ? file.extras.split(':')[0]
                                    : file.extras))
                                if (meta)
                                    if (meta.type === 'files') {
                                        if (!this._models[this.component][file.extras])
                                            this._models[this.component][file.extras] = []
                                        this._models[this.component][file.extras].push(file)
                                    } else if (meta.type === 'multiparams') {
                                        let keys = file.extras.split(':')
                                        if (!this._models[this.component][keys[0]]) {
                                            this._models[this.component][keys[0]] = {}
                                            this.models[this.component][keys[0]] = {}
                                        }

                                        if (!this._models[this.component][keys[0]][keys[1]]) {
                                            this._models[this.component][keys[0]][keys[1]] = {}
                                            this.models[this.component][keys[0]][keys[1]] = {}
                                        }
                                        this._models[this.component][keys[0]][keys[1]][keys[2]] = file
                                        this.models[this.component][keys[0]][keys[1]][keys[2]] = file
                                    }
                                    else {
                                        this._models[this.component][file.extras] = file
                                        this.models[this.component][file.extras] = file
                                    }
                            })
                    })

                    if (this.entity[this.component]?.properties['GET']) {
                        this.base.API().post(`${this.entity[this.component]?.properties['GET']}`, {
                            entity_type: this.entity_type.toUpperCase(),
                            data: {
                                id: this.dynamic ? this.id : Number(this.id)
                            }
                        }, (response) => {
                            if (this.base.Util().success(response))
                                this.load(response.data.data[0])
                            this.$emit('onloading', false)
                        }, (error) => {
                            this.$emit('onloading', false)
                        })
                    } else
                        this.$emit('onloading', false)
                } else if (this.base.Util().validate(this.contents)) {
                    this.load(this.contents)
                } else {
                    Object.keys(this.$route.query).forEach((key) => {
                        this._models[this.component][key] = this.$route.query?.[key]
                        this.models[this.component][key] = this.$route.query?.[key]
                    })
                }
            }
        },
        load(data) {
            Object.keys(data).forEach(key => {
                const meta = this.entity[this.component]?.metas?.find((meta) => meta.key === key)
                if (meta) {
                    if (meta.type === 'multiparams') {
                        data[key].split(';').forEach((element) => {
                            if (element) {
                                let row = element.split(':')[0]
                                let values = element.split(':')[1].split(',')
                                if (this.base.Util().validate(values))
                                    for (const item in values)
                                        if (this.base.Util().validate(values[item])) {
                                            let property = values[item].split('=')
                                            if (!this.base.Util().validate(this._models[this.component][key]))
                                                this._models[this.component][key] = {}
                                            if (!this.base.Util().validate(this._models[this.component][key][row]))
                                                this._models[this.component][key][row] = {}
                                            this._models[this.component][key][row][property[0]] = property[1]
                                        }
                            }
                        })
                    } else if (meta.type === 'switch')
                        this._models[this.component][key] = String(data[key]) === 'True' || String(data[key]) === 'true' ? true : false
                    else
                        this._models[this.component][key] = data[key]
                    this.models[this.component][key] = this._models[this.component][key]
                    if (meta.type === 'form') {
                        let query = {}
                        query[this.extras[this.component][meta.key]?.[meta.key]] = this._models[this.component][key]
                        this.$router.push({ path: window.location.pathname, query: query })
                    }
                }
            })
        },
        visibility() {
            this.entity[this.component]?.metas?.forEach((meta) => {
                if (!this.extras[this.component][meta.key]?.showable || this.extras[this.component][meta.key]?.showable === 'YES') {
                    let access = (this.accesses[meta.key] || this.accesses['persist'])
                    let authentic = access && ['visible', 'hidden', 'gone'].includes(access)
                    if (String(this.entity[this.component]?.properties?.excludes || '')?.includes(meta.key))
                        this.visibilities[meta.key] = 'gone'
                    else {
                        if (meta.extras && meta.extras.includes('key=v-key')) {
                            let extras = this.extras[this.component][meta.key]
                            if (extras) {
                                let key = extras['v-key']
                                if (typeof (key) === 'string')
                                    this.visibilities[meta.key] = String(this.models[this.component][key]) === String(extras[key])
                                        || (String(extras[key]) === '@' && this.base.Util().validate(this.models[this.component][key]))
                                        || (String(extras[key]) === '!@' && !this.base.Util().validate(this.models[this.component][key]))
                                        ? authentic ? access : 'visible'
                                        : this.entity[this.component].metas.find((meta) => meta.key === key)?.type === 'step' ? 'invisible' : 'gone'
                                else if (Array.isArray(key)) {
                                    let visibility = authentic ? access : 'visible'
                                    for (const element of key) {
                                        if ((!['@', '!@'].includes(String(extras[element])) && String(this.models[this.component][element]) !== String(extras[element]))
                                            || (String(extras[element]) === '@' && !this.base.Util().validate(this.models[this.component][element]))
                                            || (String(extras[element]) === '!@' && this.base.Util().validate(this.models[this.component][element]))) {
                                            visibility = this.entity[this.component].metas.find((meta) => meta.key === key)?.type === 'step'
                                                ? 'invisible' : 'gone'
                                            break
                                        }
                                    }
                                    this.visibilities[meta.key] = visibility
                                }
                                if (this.visibilities[meta.key] === 'invisible' || this.visibilities[meta.key] === 'gone')
                                    this._models[this.component][meta.key] = this.models[this.component][meta.key]
                            }
                        } else if (authentic) {
                            this.visibilities[meta.key] = access
                            if (access === 'gone')
                                this._models[this.component][meta.key] = this.models[this.component][meta.key]
                        }
                        else
                            this.visibilities[meta.key] = 'visible'
                    }
                } else
                    this.visibilities[meta.key] = 'gone'
            })
        },
        width() {
            this.entity[this.component]?.metas?.forEach((meta) => {
                if (meta.style) {
                    let width = JSON.parse(meta.style)?.width
                    if (width && String(width).includes('%')) {
                        width = Number(String(width).replace('%', ''))
                        if (window.screen.width <= 765) {
                            if (width >= 20 && width <= 30) {
                                let style = JSON.parse(meta.style)
                                style.width = '48%'
                                meta.style = JSON.stringify(style)
                            } else if (width >= 70 && width <= 80) {
                                let style = JSON.parse(meta.style)
                                style.width = '100%'
                                meta.style = JSON.stringify(style)
                            }
                        }

                        if (window.screen.width <= 680) {
                            if (width >= 30 && width <= 40) {
                                let style = JSON.parse(meta.style)
                                style.width = '48%'
                                meta.style = JSON.stringify(style)
                            }
                        }

                        if (window.screen.width <= 580) {
                            let style = JSON.parse(meta.style)
                            style.width = '100%'
                            meta.style = JSON.stringify(style)
                        }
                    }
                }
            })
        },
        fetch(data) {
            this.base.API().post(`${this.entity[this.component]?.properties['GET']}`, {
                entity_type: this.entity_type.toUpperCase(),
                data: data
            }, (response) => {
                if (this.base.Util().success(response)) {
                    let data = response.data.data[0]
                    Object.keys(data).forEach(key => {
                        const meta = this.entity[this.component]?.metas?.find((meta) => meta.key === key)
                        if (meta) {
                            if (meta.type === 'multiparams') {
                                data[key].split(';').forEach((element) => {
                                    let row = element.split(':')[0]
                                    let values = element.split(':')[1].split(',')
                                    for (const item in values) {
                                        let property = values[item].split('=')
                                        if (!this.base.Util().validate(this._models[this.component][key]))
                                            this._models[this.component][key] = {}
                                        if (!this.base.Util().validate(this._models[this.component][key][row]))
                                            this._models[this.component][key][row] = {}
                                        this._models[this.component][key][row][property[0]] = property[1]
                                    }
                                })
                            } else if (meta.type === 'switch')
                                this._models[this.component][key] = data[key] === 'True' || data[value] === 'true' ? true : false
                            else
                                this._models[this.component][key] = data[key]
                            this.models[this.component][key] = this._models[this.component][key]
                        }
                    })
                }
            }, (error) => {
            })
        },
        onfocus(obj) {
            this.focus = obj.value ? obj.key : ''

            this.$emit('onfocus', {
                focus: this.focus
            })
        },
        onchange(obj) {
            this.models[this.component][obj.key] = obj.value
            this.hints[this.component][obj.key] = obj.hint
            this.errors[this.component][obj.key] = obj.error

            this.$emit('onchange', {
                models: this.models,
                hints: this.hints,
                errors: this.errors
            })
        },
        onloading(status) {
            this.$emit('onloading', status)
        }
    }
}
</script>